const campaignsData = [
	{
		campaignThumbnail: require('./enter-name.gif'),
		title: 'Choose username',
		btnText: '1',
		btnLink: 'https://www.69work.com/marketplace/register',
	},
	{
		campaignThumbnail: require('./hostjane-subreddit.jpg'),
		title: 'Share pay link',
		btnText: '2',
		btnLink: 'https://www.69work.com/marketplace/register',
	},
	{
		campaignThumbnail: require('./hostjane-discord.jpg'),
		title: 'Get your gift',
		btnText: '3',
		btnLink: 'https://www.69work.com/marketplace/register',
	},
];

export default campaignsData;
